// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".container[data-v-451b682a] {\n  display: flex;\n  flex-direction: column;\n}\n.container .tittle[data-v-451b682a] {\n  font-size: 16px;\n  font-weight: 600;\n  line-height: 26px;\n  padding-bottom: 10px;\n}\n.container .filter-tree[data-v-451b682a] {\n  padding-top: 10px;\n}\n.container .dialog-footer[data-v-451b682a] {\n  position: absolute;\n  bottom: 0;\n  right: 20px;\n  display: flex;\n  justify-content: flex-end;\n  width: 100%;\n}\n", ""]);
// Exports
module.exports = exports;
